import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Container } from '../base';

const Nav = props => {
  const navClassName = classNames({
    'navbar-collapse': true,
    collapse: !props.expanded,
    [props.className]: props.className,
  });

  return (
    <div className={navClassName} style={{ top: props.topPosition }}>
      {props.children}
    </div>
  );
};

Nav.propTypes = {
  topPosition: PropTypes.number,
  expanded: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
};

const NavItem = props => {
  // The dropdown is CSS-driven, so after a link click the cursor and focus keep
  // it open while Next.js reuses the header (same page component). Suppress it
  // until the pointer leaves or keyboard focus comes back.
  const [closed, setClosed] = useState(false);

  const handleClick = e => {
    if (!e.target.closest('a')) return;

    setClosed(true);
    document.activeElement?.blur();
  };

  const className = classNames('list-item', 'nav-item', { 'nav-item-closed': closed });

  return (
    // Dropdown children are always in the DOM so crawlers see the links in
    // server-rendered HTML; visibility is handled by the `.nav-item:hover
    // .nav-canvas` CSS rules.
    <li
      className={className}
      onClick={handleClick}
      onMouseLeave={() => setClosed(false)}
      onFocus={() => setClosed(false)}
    >
      {props.link}
      {props.hasChild && (
        <div className="nav-canvas">
          <Container>{props.children}</Container>
        </div>
      )}
    </li>
  );
};

NavItem.propTypes = {
  hasChild: PropTypes.bool,
  link: PropTypes.node,
  children: PropTypes.node,
};

Nav.Item = NavItem;

export default Nav;
